import { jsx as _jsx } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import DetailedTermSelector from 'pricing-pages-ui/components/common/DetailedTermSelector';
import { currentSkuIdForProductSelector } from 'pricing-pages-ui/selectors/ProductsSelectors';
import { crmSuiteAvailableTermsSelector } from 'pricing-pages-ui/selectors/OfferSelectors';
import Whitespace from 'pricing-pages-ui/components/common/Whitespace';
import { CRM_SUITE_PRODUCTS } from 'pricing-pages-lib/utils/productsUtils';
import styled from 'styled-components';
import { NavItemEnum } from '../../constants/routing/NavItems';
const StyledTermSelectorContainer = styled(DetailedTermSelector).withConfig({
  displayName: "SuiteTermSelectorContainer__StyledTermSelectorContainer",
  componentId: "sc-178heh8-0"
})(["margin:0 auto;"]);

const SuiteTermSelectorContainer = ({
  queryParamTerm,
  productLevel,
  onChange,
  trackingSource
}) => {
  const skuIds = useSelector(reduxState => {
    return CRM_SUITE_PRODUCTS[productLevel].map(productLine => {
      return currentSkuIdForProductSelector(reduxState, {
        productLine,
        productLevel
      });
    });
  });
  const hasMultipleTerms = useSelector(reduxState => crmSuiteAvailableTermsSelector(reduxState, {
    productLevel
  })).length > 1;

  if (!hasMultipleTerms) {
    return /*#__PURE__*/_jsx(Whitespace, {
      height: 41
    });
  }

  const trackingSourceString = `${trackingSource}-${productLevel.toLowerCase()}`;
  return /*#__PURE__*/_jsx(StyledTermSelectorContainer, {
    skuIds: skuIds,
    onChange: onChange,
    trackingSource: trackingSourceString,
    activeTerm: queryParamTerm,
    screen: NavItemEnum.SUITE
  });
};

export default SuiteTermSelectorContainer;